export default "__VITE_ASSET__455de779__"